"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _SimpleFilterSelector = _interopRequireDefault(require("../../../overview/filters/SimpleFilterSelector"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _PillContainer = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/PillContainer"));

var _Pill = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/Pill"));

var _TextButton = _interopRequireDefault(require("../../../ui-components/TextButton"));

var _classnames = _interopRequireDefault(require("classnames"));

var CrmAccountValuesSelector = function CrmAccountValuesSelector(_ref) {
  var id = _ref.id,
      name = _ref.name,
      title = _ref.title,
      isDropdownOpen = _ref.isDropdownOpen,
      toggleDropdown = _ref.toggleDropdown,
      resetDropdown = _ref.resetDropdown,
      items = _ref.items,
      selectedItems = _ref.selectedItems,
      selectedField = _ref.selectedField,
      onChange = _ref.onChange;

  var onRemoveItem = function onRemoveItem(e, selectedItem) {
    e.stopPropagation();
    var filteredList = selectedItems.filter(function (item) {
      return item !== selectedItem;
    });
    onChange(filteredList);
  };

  var valueLabelMap = (selectedField === null || selectedField === void 0 ? void 0 : selectedField.values.reduce(function (vMap, v) {
    if (v !== null && v !== void 0 && v.value) {
      vMap[v.value.toLowerCase()] = v;
    }

    return vMap;
  }, {})) || {};
  var triggerTitle = (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 ? (0, _preact.h)("div", {
    className: "crm-values-field-pills-wrapper"
  }, selectedItems.map(function (item) {
    var _valueLabelMap$item$t;

    var itemLabel = (_valueLabelMap$item$t = valueLabelMap[item.toLowerCase()]) === null || _valueLabelMap$item$t === void 0 ? void 0 : _valueLabelMap$item$t.label;
    return (0, _preact.h)(_Pill.default, {
      key: item,
      isValid: !!itemLabel
    }, (0, _preact.h)("span", null, itemLabel || item), (0, _preact.h)(_assets.default, {
      customClass: "qa-dismiss-filter-pill",
      icon: "close",
      width: 16,
      height: 16,
      onClick: function onClick(e) {
        return onRemoveItem(e, item);
      }
    }));
  })) : title;
  return (0, _preact.h)(_PillContainer.default, null, (0, _preact.h)("div", {
    className: "dropdown-container crm-field-selector-trigger"
  }, (0, _preact.h)(_TextButton.default, {
    "aria-haspopup": "listbox",
    "aria-expanded": isDropdownOpen
  }, (0, _preact.h)(_Button.default, {
    title: triggerTitle,
    className: "integrations-salesforce_field-selector".concat(isDropdownOpen ? ' crm-field-selector-is-open' : ''),
    icon: "chevronDown",
    onClick: function onClick() {
      return toggleDropdown(!isDropdownOpen);
    }
  })), isDropdownOpen && (0, _preact.h)("ul", {
    className: (0, _classnames.default)('control-dropdown', 'control-dropdown--brand', 'crm-value-field-list')
  }, (0, _preact.h)("div", {
    className: "control-dropdown__list control-dropdown__list--adjust"
  }, (0, _preact.h)(_SimpleFilterSelector.default, {
    id: id,
    name: name,
    isSearchable: true,
    items: items,
    selectedFilterItems: selectedItems
  }, function (_ref2) {
    var isApplyButtonDisabled = _ref2.isApplyButtonDisabled,
        data = _ref2.data;
    return (0, _preact.h)("div", {
      className: "sticky-overview__filters-box-buttons"
    }, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
      className: "overview__filters-box-buttons"
    }, (0, _preact.h)(_Button.default, {
      size: "small",
      variant: "brand",
      title: "Apply",
      disabled: isApplyButtonDisabled,
      onClick: function onClick() {
        return onChange(data);
      }
    }), (0, _preact.h)(_Button.default, {
      size: "small",
      title: "Cancel",
      onClick: resetDropdown
    })));
  })))));
};

var _default = CrmAccountValuesSelector;
exports.default = _default;